import { render, staticRenderFns } from "./MemberTasks.vue?vue&type=template&id=22df43f9"
import script from "./MemberTasks.vue?vue&type=script&lang=ts"
export * from "./MemberTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports